/**
 * Chart type options per report type. Used by shared ChartTypeDropdown.
 * Insight: full set. Funnel: Funnel Steps, Line, Bar, Metric.
 */
export const INSIGHT_CHART_TYPES = [
  { id: "line", label: "Line", iconName: "linechart" },
  { id: "stacked-line", label: "Stacked Line", iconName: "stacked_linechart" },
  { id: "column", label: "Column & Bar", iconName: "barchart" },
  { id: "stacked-column", label: "Stacked Column", iconName: "stacked_barchart" },
  { id: "bar", label: "Bar", iconName: "barchart" },
  { id: "stacked-bar", label: "Stacked Bar", iconName: "stacked_barchart" },
  { id: "pie", label: "Pie", iconName: "piechart" },
  { id: "table", label: "Table", iconName: "table" },
  { id: "metric", label: "Metric", iconName: "metric" },
];

export const FUNNEL_CHART_TYPES = [
  { id: "funnel-steps", label: "Funnel Steps", iconName: "funnel" },
  { id: "line", label: "Line", iconName: "linechart" },
  { id: "bar", label: "Bar", iconName: "barchart" },
  { id: "metric", label: "Metric", iconName: "metric" },
];

export const RETENTION_CHART_TYPES = [
  { id: "retention-curve", label: "Retention Curve", iconName: "linechart" },
  { id: "line", label: "Line", iconName: "linechart" },
  { id: "metric", label: "Metric", iconName: "metric" },
];

/**
 * @param {"insight" | "funnel" | "retention"} reportType
 * @returns {Array<{ id: string, label: string, iconName?: string, icon?: React.ComponentType, disabled?: boolean }>}
 */
export function getChartTypesForReportType(reportType) {
  if (reportType === "funnel") {
    return FUNNEL_CHART_TYPES;
  }
  if (reportType === "retention") {
    return RETENTION_CHART_TYPES;
  }
  return INSIGHT_CHART_TYPES;
}
